import {
  UPDATE_LOCATION_CITY,
  UPDATE_CURRENT_CITY,
  UPDATE_LOCATION,
  UPDATE_HOT_CITY_LIST,
  UPDATE_OPEN_CITY_LIST,
  UPDATE_CURRENT_LOCATION,
  UPDATE_HISTORY_ADDRESS,
  UPDATE_LOCATION_TIPS,
  UPDATE_IS_LOADED_LOCATION,
  UPDATE_LINK_PARAM_CACHE,
  UPDATE_ENTRY_HREF,
  UPDATE_LOCATION_ADDRESS,
  UPDATE_CHECK_ADDRESS
} from '../mutation-types'
import superagent from 'superagent'
import Config from './config'
import jsonp from 'superagent-jsonp'
import BMap from 'BMap'
const baseUrl = 'https://wx.dudubashi.com' // 替换为基本URL

const state = {
  current_city: '',
  cache_entry_href: '', // 进入页面时的href
  location_city: window.sessionStorage.getItem('location_city') || window.localStorage.getItem('location_city_cache'),
  current_pos: JSON.parse(window.sessionStorage.getItem('current_pos')),
  current_pos_address: '', // 定位点解析详情，iadmin 过来的
  location: {
    commute_start: {},
    commute_end: {},
    feeder_start: {}, // 接驳及穿梭车起始地址
    feeder_end: {}, // 接驳及穿梭车终点地址
    home: {},
    company: {},
    organize_start: {},
    organize_end: {}
  },
  hot_city_list: [],
  open_city_list: {},
  open_city_name_list: [],
  open_city_name_object: {},
  history_address: window.localStorage.getItem('commute_history_address') ? JSON.parse(window.localStorage.getItem('commute_history_address')) : [],
  show_location_tips: false,
  is_loaded_location: false, // 是否已经定位过状态
  link_param_cache: '', // 缓存华为链接传过来的参数
  link_param_cache_time: 0, // 缓存查询链接参数时间
  cache_check_address: '' // search map 选中的地址
}

const mutations = {
  [UPDATE_LOCATION_CITY] (state, city_name) {
    if (city_name) {
      window.localStorage.setItem('location_city_cache', city_name)
    }
    if (window.localStorage && city_name) {
      window.localStorage.setItem('cacheLocationCity', city_name)
    }
    state.location_city = city_name
  },
  [UPDATE_CHECK_ADDRESS] (state, data) {
    state.cache_check_address = data
  },
  [UPDATE_CURRENT_CITY] (state, city_name) {
    if (city_name) {
      window.localStorage.setItem('location_city_cache', city_name)
    }
    if (window.localStorage && city_name) {
      window.localStorage.setItem('cacheLocationCity', city_name)
    }
    state.current_city = city_name
  },
  [UPDATE_LOCATION] (state, params) {
    state.location[params.from] = params.location
  },
  [UPDATE_LOCATION_ADDRESS] (state, address) {
    state.current_pos_address = address
  },
  [UPDATE_HOT_CITY_LIST] (state, list) {
    state.hot_city_list = list
  },
  [UPDATE_OPEN_CITY_LIST] (state, list) {
    state.open_city_list = list
    var _list = []
    var _item = {}
    for (var one in list) {
      var city_list = list[one]
      for (var i = 0, len = city_list.length; i < len; i++) {
        _list.push(city_list[i].city_name)
        _item[city_list[i].city_name] = {
          name: city_list[i].city_name,
          id: city_list[i].city_id,
          phone: city_list[i].service_phone
        }
      }
    }
    state.open_city_name_list = _list
    state.open_city_name_object = _item
  },
  [UPDATE_CURRENT_LOCATION] (state, point) {
    state.current_pos = point
    state.is_loaded_location = true
    if (window.localStorage && point) {
      window.localStorage.setItem('cacheLocationPoint', JSON.stringify(point))
    }
  },
  [UPDATE_LINK_PARAM_CACHE] (state, param) {
    state.link_param_cache = param
    state.link_param_cache_time = new Date().getTime()
  },
  [UPDATE_HISTORY_ADDRESS] (state, data) {
    // 如果已经存在列表里，则删除后插入到前面
    for (var i = 0, len = state.history_address.length; i < len; i++) {
      var _item = state.history_address[i]
      if ((_item.point.lng === data.point.lng && _item.point.lat === data.point.lat) || _item.address_title === _item.address_title) {
        state.history_address.splice(i, 1)
        break
      }
    }
    state.history_address.unshift(data)
    // 只存储十条
    if (state.history_address.length > 10) {
      state.history_address.pop()
    }
    window.localStorage.setItem('commute_history_address', JSON.stringify(state.history_address))
  },
  [UPDATE_LOCATION_TIPS] (state, data) {
    state.show_location_tips = data
  },
  [UPDATE_IS_LOADED_LOCATION] (state, data) {
    state.is_loaded_location = data
  },
  [UPDATE_ENTRY_HREF] (state, link) {
    state.cache_entry_href = link
  }
}

const actions = {
  setParamCurrentPos ({ commit }, point) {
    superagent
    .get(window.location.protocol + '//api.map.baidu.com/geocoder/v2/')
    .query({
      output: 'json',
      ak: 'b2tdmZtPCKfwW8iwn5svaT03',
      location: point.lat + ',' + point.lng
    })
    .set('Accept', 'application/json')
    .use(jsonp)
    .end(function (err, res) {
      if (err) {
        // throw err
      } else {
        if (res.body.status === 0) {
          res = res.body.result
          res.addressComponent = res.addressComponent || {}
          commit('UPDATE_LOCATION_CITY', res.addressComponent.city)
          var _location = {
            is_current_pos: true
          }
          if (res.formatted_address && res.addressComponent.city && res.addressComponent.province) {
            _location.address = res.formatted_address
            _location.city = res.addressComponent.city
            _location.province = res.addressComponent.province
            if (res.sematic_description) {
              _location.address_title = res.sematic_description
            } else {
              var _address_title = _location.address.replace(res.addressComponent.province, '')
              _address_title = _address_title.replace(res.addressComponent.city, '')
              _location.address_title = _address_title
            }
            _location.point = res.location
            if (_location.point) {
              _location.associate_location = _location.point.lng + ',' + _location.point.lat
            }
            // 班次列表的 默认当前位置
            commit('UPDATE_LOCATION', {
              from: 'commute_start',
              location: _location
            })
            commit('UPDATE_LOCATION_ADDRESS', _location.address || '')
          }
          commit('UPDATE_CURRENT_LOCATION', point)
        }
      }
    })
  },
  getCurrentCity ({ commit, state }, show_tips) {
    var geolocation = new BMap.Geolocation()
    var geoc = new BMap.Geocoder()
    // result：地理定位结果，包含point
    geolocation.getCurrentPosition(function (result) {
      var _status = this.getStatus()
      if (_status === window.BMAP_STATUS_SUCCESS) {
        geoc.getLocation(result.point, function (res) {
          res.addressComponents = res.addressComponents || {}
          // res：地址逆解析结果，包含地址相关信息
          commit('UPDATE_LOCATION_CITY', res.addressComponents.city || '')
          commit('UPDATE_CURRENT_LOCATION', res.point)
          // 班次列表的 默认当前位置
          if (!state.location.commute_start.address_title) {
            var address_title = res.address
            address_title = address_title.replace(res.addressComponents.city, '')
            address_title = address_title.replace(res.addressComponents.province, '')
            var _location = {
              city: res.addressComponents.city,
              province: res.addressComponents.province,
              point: res.point,
              address_title: address_title,
              is_current_pos: true
            }
            if (res.point) {
              _location.associate_location = res.point.lng + ',' + res.point.lat
            }
            commit('UPDATE_LOCATION', {
              from: 'commute_start',
              location: _location
            })
          }
          if (show_tips) {
            commit('UPDATE_LOCATION_TIPS', true)
          }
        })
      } else {
        if (!window.localStorage.getItem('location_city_cache')) {
          window.alert('定位失败：' + _status)
        }
        if (show_tips) {
          commit('UPDATE_LOCATION_TIPS', true)
        }
      }
    }, function () {
      if (show_tips) {
        commit('UPDATE_LOCATION_TIPS', true)
      }
    }, {
      enableHighAccuracy: true
    })
  },
  getCityPoint ({ commit, state }, city) {
    // 根据地址获取经纬度
    var _city = city + ''
    if (_city.indexOf('市') === -1) {
      _city = _city + '市'
    }
    var geoc = new BMap.Geocoder()
    return new Promise(function (resolve, reject) {
      geoc.getPoint(_city, function (point) {
        if (point) {
          commit('UPDATE_CURRENT_LOCATION', point)
        } else {
          // console.log('查询失败', point)
        }
        resolve(point)
      })
    })
  },
  // params { keyword: 'xxx', city: 'xxx' }
  searchAddress ({ commit, state }, params) {
    var _city = params.city ? params.city : (state.current_city || state.location_city)
    if (params.keyword.length > 0) {
      var _param = {
        ak: 'b2tdmZtPCKfwW8iwn5svaT03',
        region: _city,
        output: 'json',
        query: params.keyword
      }
      return new Promise(function (resolve, reject) {
        superagent
        .get(window.location.protocol + '//api.map.baidu.com/place/v2/suggestion')
        .query(_param)
        .set('Accept', 'application/json')
        .use(jsonp)
        .end(function (err, res) {
          if (err) {
            // console.log(err)
          } else {
            // 过滤location
            var _arr = []
            for (var i = 0, len = res.body.result.length; i < len; i++) {
              var _place = res.body.result[i]
              if (_place.location) {
                _arr.push({
                  address_title: _place.name,
                  point: _place.location
                })
              }
            }
            resolve(_arr)
          }
        })
      })
    }
  },
  geocoder ({ commit, state }, arr) {
    // 逆解析 http://api.map.baidu.com/geocoder/v2/
    var _promise_arr = []
    for (var i = 0, len = arr.length; i < len; i++) {
      var _p = new Promise(function (resolve, reject) {
        superagent
        .get(window.location.protocol + '//api.map.baidu.com/geocoder/v2/')
        .query({
          output: 'json',
          ak: 'b2tdmZtPCKfwW8iwn5svaT03',
          location: arr[i].point.lat + ',' + arr[i].point.lng
        })
        .set('Accept', 'application/json')
        .use(jsonp)
        .end(function (err, res) {
          if (err) {
            // console.log(err)
          } else {
            resolve(res)
          }
        })
      })
      _promise_arr.push(_p)
    }
    return Promise.all(_promise_arr)
  },
  // location, from
  setAddress ({ commit, state }, params) {
    commit('UPDATE_LOCATION', params)
    if (params.location.associate_address && !params.no_history) {
      commit('UPDATE_HISTORY_ADDRESS', params.location)
    }
  },
  addHistoryAddress ({ commit, state }, params) {
    commit('UPDATE_HISTORY_ADDRESS', params.location)
  },
  setCacheAddress ({ commit, state }, params) {
    commit('UPDATE_CHECK_ADDRESS', params)
  },
  getHotCity ({ commit, state }) {
    superagent
    .post(baseUrl + '/index.php/home/city/get_bus_hot_city')
    .end(function (err, res) {
      if (err) throw err
      let _data = JSON.parse(res.text)
      if (_data.result === '0000') {
        commit('UPDATE_HOT_CITY_LIST', _data.data)
      }
    })
  },
  getOpenCity ({ commit, state }) {
    superagent
    .post(baseUrl + '/index.php/line/enterprise/get_open_citys')
    .send({
      enterprise_id: Config.state.enterprise_id
    })
    .type('form')
    .end(function (err, res) {
      if (err) throw err
      let _data = JSON.parse(res.text)
      if (_data.result === '0000') {
        commit('UPDATE_OPEN_CITY_LIST', _data.data)
      }
    })
  },
  setCurrentCity ({ commit, state }, city_name) {
    commit('UPDATE_CURRENT_CITY', city_name)
  },
  setLoadedLocation ({ commit, state }, status) {
    commit('UPDATE_IS_LOADED_LOCATION', status)
  },
  exchangeLocation ({ commit, state }, callback) {
    // 切换开始及结束位置
    var _start = JSON.parse(JSON.stringify(state.location.commute_start || {}))
    var _end = JSON.parse(JSON.stringify(state.location.commute_end || {}))

    commit('UPDATE_LOCATION', {
      from: 'commute_start',
      location: _end
    })
    commit('UPDATE_LOCATION', {
      from: 'commute_end',
      location: _start
    })
    if (callback) {
      // 执行回调
      callback()
    }
  },
  setCompanyAddress ({ commit }, location) {
    commit('UPDATE_LOCATION', {
      from: 'organize_end',
      location: location
    })
  },
  getWXLocation ({ commit }) {
    var convertor = new BMap.Convertor()
    return new Promise(function (resolve, reject) {
      window.wx.ready(function () {
        window.wx.getLocation({
          type: 'gcj02',
          success: function (res) {
            var lat = res.latitude
            var lng = res.longitude
            convertor.translate([new BMap.Point(lng, lat)], 3, 5, function (data) {
              if (data.status === 0) {
                resolve(data.points[0])
              }
            })
          },
          cancel: function (res) {
            reject('用户拒绝授权获取地理位置')
            // window.alert('用户拒绝授权获取地理位置')
          },
          fail: function (res) {
            reject(JSON.stringify(res))
            // window.alert(JSON.stringify(res))
          }
        })
      })
    })
  }
}

export default {
  namespaced: true,
  actions,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/address.js